import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

const basePath = '/user/reset_password';

@Injectable({
  providedIn: 'root'
})
export class UserPasswordService {

  constructor(
    private http: HttpClient
  ) { }

  // Send password reset email. No content Response.
  resetUserPassword(usernameOrEmail: string) {
    const body = { usernameOrEmail: usernameOrEmail };
    return this.http.post(`${basePath}`, body);
  }

}
